import React from 'react';
import { withAllContexts } from '../../AllContextsWrapper';
import { ArrowLeft, Users, RefreshCw, AlertTriangle, Check, Trash2, Search, Filter } from 'lucide-react';

class AdminClientsPage extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            mode: 'list', // 'list' | 'duplicates'
            clients: [],
            duplicates: [],
            loading: true,
            selectedCompanyId: 1, // Default to 1 for now
            companies: [{ id: 1, name: "Moja Firma" }], // Mock or fetch real
            searchQuery: '',
            duplicateRefreshing: false
        };
    }

    componentDidMount() {
        this.fetchClients();
    }

    fetchClients = () => {
        this.setState({ loading: true });
        this.props.socketIO.socket.emit('client:getAll', { company_id: this.state.selectedCompanyId }, (response) => {
            if (response.success) {
                this.setState({ clients: response.data, loading: false });
            } else {
                this.setState({ loading: false });
                alert("Chyba pri načítaní klientov");
            }
        });
    }

    fetchDuplicates = () => {
        this.setState({ duplicateRefreshing: true });
        this.props.socketIO.socket.emit('client:getDuplicates', this.state.selectedCompanyId, (response) => {
            if (response.success) {
                this.setState({ duplicates: response.data, duplicateRefreshing: false, mode: 'duplicates' });
            } else {
                this.setState({ duplicateRefreshing: false });
                alert("Chyba pri hľadaní duplicít");
            }
        });
    }

    mergeClients = (keepId, mergeId) => {
        if (!window.confirm("Naozaj chcete zlúčiť týchto klientov? Druhý klient bude zmazaný a všetky údaje presunuté.")) return;

        this.props.socketIO.socket.emit('client:merge', { keepId, mergeId }, (response) => {
            if (response.success) {
                // Remove the merged group or update list locally
                this.fetchDuplicates(); // Refresh duplicates list
            } else {
                alert("Chyba pri zlučovaní: " + (response.err || 'Neznáma chyba'));
            }
        });
    }

    handleDuplicateChange = (groupIndex, clientId, field, value) => {
        const newDuplicates = [...this.state.duplicates];
        const group = newDuplicates[groupIndex];
        const client = group.clients.find(c => c.id === clientId);
        if (client) {
            client[field] = value;
            this.setState({ duplicates: newDuplicates });
        }
    }

    renderDuplicates = () => {
        const { duplicates, duplicateRefreshing } = this.state;

        if (duplicateRefreshing) {
            return <div className="p-12 text-center text-gray-500">Hľadám duplicity...</div>;
        }

        if (!duplicates || duplicates.length === 0) {
            return (
                <div className="p-12 text-center flex flex-col items-center">
                    <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-4">
                        <Check className="w-8 h-8" />
                    </div>
                    <h3 className="text-lg font-medium text-gray-900">Všetko čisté!</h3>
                    <p className="text-gray-500 mt-2">Nenašli sa žiadne duplicitné telefónne čísla.</p>
                </div>
            );
        }

        return (
            <div className="space-y-8">
                {duplicates.map((group, idx) => (
                    <div key={idx} className="bg-white rounded-xl shadow-sm border border-yellow-200 overflow-hidden">
                        <div className="bg-yellow-50 px-6 py-3 border-b border-yellow-100 flex items-center gap-2">
                            <AlertTriangle className="w-5 h-5 text-yellow-600" />
                            <h3 className="font-semibold text-yellow-800">
                                Konflikt č. {idx + 1}: {group.phone_normalized}
                            </h3>
                        </div>
                        <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {group.clients.map(client => (
                                <div key={client.id} className="relative border-2 border-transparent hover:border-blue-500 rounded-lg p-4 bg-gray-50 transition-all group">
                                    <div className="flex justify-between items-start mb-4">
                                        <div className="flex-1">
                                            {/* Name Input */}
                                            <input
                                                type="text"
                                                value={client.name || ''}
                                                onChange={(e) => this.handleDuplicateChange(idx, client.id, 'name', e.target.value)}
                                                className="w-full font-bold text-lg text-gray-900 bg-transparent border-b border-transparent hover:border-gray-300 focus:border-blue-500 focus:ring-0 px-0 py-1 transition-colors mb-1"
                                                placeholder="Meno klienta"
                                            />
                                            <div className="text-sm font-mono text-gray-600 bg-gray-200 px-2 py-0.5 rounded inline-block">
                                                ID: {client.id}
                                            </div>
                                        </div>
                                        <div className="text-right ml-4">
                                            <div className="text-2xl font-bold text-blue-600">{client.reservationCount}</div>
                                            <div className="text-xs text-gray-500 uppercase tracking-wide">Rezervácií</div>
                                        </div>
                                    </div>

                                    <div className="space-y-3 text-sm text-gray-600 mb-6">
                                        <div className="flex flex-col">
                                            <label className="text-xs text-gray-500 mb-1">Telefón</label>
                                            <input
                                                type="text"
                                                value={client.phone || ''}
                                                onChange={(e) => this.handleDuplicateChange(idx, client.id, 'phone', e.target.value)}
                                                className="w-full bg-white border border-gray-300 rounded px-2 py-1.5 focus:ring-2 focus:ring-blue-500 outline-none"
                                            />
                                        </div>
                                        <div className="flex flex-col">
                                            <label className="text-xs text-gray-500 mb-1">Email</label>
                                            <input
                                                type="text"
                                                value={client.email || ''}
                                                onChange={(e) => this.handleDuplicateChange(idx, client.id, 'email', e.target.value)}
                                                className="w-full bg-white border border-gray-300 rounded px-2 py-1.5 focus:ring-2 focus:ring-blue-500 outline-none"
                                            />
                                        </div>
                                        <div className="flex justify-between pt-2 border-t border-gray-200 mt-2">
                                            <span>Vytvorené:</span>
                                            <span className="">{new Date(client.createdAt).toLocaleDateString()}</span>
                                        </div>
                                    </div>

                                    <button
                                        onClick={() => {
                                            const others = group.clients.filter(c => c.id !== client.id);
                                            // Confirm for all
                                            if (window.confirm(`Chcete ponechať klienta "${client.name}" (ID ${client.id}) a zlúčiť do neho ostatných (${others.length})?`)) {

                                                const updates = {
                                                    name: client.name,
                                                    phone: client.phone,
                                                    email: client.email
                                                };

                                                others.forEach(other => {
                                                    this.props.socketIO.socket.emit('client:merge', {
                                                        keepId: client.id,
                                                        mergeId: other.id,
                                                        updates: updates
                                                    }, (res) => {
                                                        if (res.success) {
                                                            // Good
                                                        } else {
                                                            console.error("Merge failed", res);
                                                            alert("Zlučovanie zlyhalo: " + (res.err || "Unknown error"));
                                                        }
                                                    })
                                                });
                                                // Refresh after delay
                                                setTimeout(this.fetchDuplicates, 1000);
                                            }
                                        }}
                                        className="w-full py-2 bg-white border border-green-600 text-green-700 font-medium rounded-lg hover:bg-green-50 transition-colors flex items-center justify-center gap-2"
                                    >
                                        <Check className="w-4 h-4" />
                                        Ponechať tohto
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    renderList = () => {
        const { clients, searchQuery, loading } = this.state;

        let filteredClients = clients;
        if (searchQuery) {
            const low = searchQuery.toLowerCase();
            filteredClients = clients.filter(c =>
                (c.name && c.name.toLowerCase().includes(low)) ||
                (c.phone && c.phone.includes(low)) ||
                (c.email && c.email.toLowerCase().includes(low))
            );
        }

        if (loading) return <div className="p-12 text-center text-gray-500">Načítavam...</div>;

        return (
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                    <div className="relative max-w-sm w-full flex items-center">
                        <Search className="w-5 h-5 absolute left-3 text-gray-400 pointer-events-none" />
                        <input
                            type="text"
                            placeholder="Hľadať meno, telefón, email..."
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                            value={searchQuery}
                            onChange={e => this.setState({ searchQuery: e.target.value })}
                        />
                    </div>
                    <div className="text-sm text-gray-500">
                        Zobrazených {filteredClients.length} klientov
                    </div>
                </div>
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm">
                        <thead className="bg-gray-50 text-gray-600 font-medium border-b border-gray-200">
                            <tr>
                                <th className="px-6 py-3">ID</th>
                                <th className="px-6 py-3">Meno</th>
                                <th className="px-6 py-3">Telefón</th>
                                <th className="px-6 py-3">Email</th>
                                <th className="px-6 py-3">Vytvorený</th>
                                <th className="px-6 py-3"></th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {filteredClients.slice(0, 100).map(client => (
                                <tr key={client.id} className="hover:bg-gray-50">
                                    <td className="px-6 py-3 text-gray-500">#{client.id}</td>
                                    <td className="px-6 py-3 font-medium text-gray-900">{client.name}</td>
                                    <td className="px-6 py-3">{client.phone}</td>
                                    <td className="px-6 py-3 text-gray-500">{client.email || '-'}</td>
                                    <td className="px-6 py-3 text-gray-500">{new Date(client.createdAt).toLocaleDateString()}</td>
                                    <td className="px-6 py-3 text-right">
                                        {/* Actions could go here */}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {filteredClients.length > 100 && (
                        <div className="p-4 text-center text-xs text-gray-500 bg-gray-50 border-t border-gray-200">
                            Zobrazených prvých 100 záznamov. Použite vyhľadávanie pre viac.
                        </div>
                    )}
                </div>
            </div>
        )
    }

    render() {
        const { mode } = this.state;

        return (
            <div className="min-h-screen bg-gray-50 flex flex-col">
                {/* Header */}
                <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between shadow-sm sticky top-0 z-30">
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => window.history.back()}
                            className="p-2 hover:bg-gray-100 rounded-full text-gray-600 transition-colors"
                        >
                            <ArrowLeft className="w-6 h-6" />
                        </button>
                        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
                            <Users className="w-8 h-8 text-blue-600" />
                            Správa Klientov
                        </h1>
                    </div>

                    <div className="flex items-center gap-4">
                        <div className="flex items-center gap-2 bg-gray-100 p-1 rounded-lg">
                            <button
                                onClick={() => { this.setState({ mode: 'list' }); this.fetchClients(); }}
                                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${mode === 'list'
                                    ? 'bg-white text-blue-700 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'}`}
                            >
                                Zoznam
                            </button>
                            <button
                                onClick={this.fetchDuplicates}
                                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${mode === 'duplicates'
                                    ? 'bg-white text-blue-700 shadow-sm'
                                    : 'text-gray-600 hover:text-gray-900'}`}
                            >
                                Duplicity
                            </button>
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="flex-1 p-6 max-w-7xl mx-auto w-full">
                    {mode === 'list' ? this.renderList() : this.renderDuplicates()}
                </div>
            </div>
        )
    }
}

export default withAllContexts(AdminClientsPage);
